import { FormBase } from 'core/components';

export default class CloseOutExitForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.state.options.set({
			validateOnChange: false,
		});
	}
	setup() {
		return {
			fields: [
				{
					name: 'warehouseId',
					label: 'CLOSEOUTEXITVIEW.WAREHOUSE',
					rules: 'required',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/CloseOutExitForm.js